import { RootState } from "../index";

/* Select Creators */
export const selectIsCartOpen = (state: RootState) => state.cart.isCartOpen;
export const selectCartItems = (state: RootState) => state.cart.cartItems;
export const selectIsCartLoaded = (state: RootState) => state.cart.isCartLoaded;

export const selectTotalPrice = (state: RootState) =>
  +state.cart.cartItems
    .reduce((acc, { configuration }) => acc + configuration.price * configuration.quantity, 0)
    .toFixed(2);

export const selectOldTotalPrice = (state: RootState) =>
  +state.cart.cartItems
    .reduce((acc, { configuration }) => acc + configuration.oldPrice * configuration.quantity, 0)
    .toFixed(2);
